<template>
  <div class="mapping" v-if="value">
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label>WS Name</label>
          <input type="text" v-model="value.service_code" class="form-control" list="ws-services" />
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label>FS Name</label>
          <select class="form-control" v-model="value.freightsolution_service_name">
            <option :value="null">---</option>
            <option :key="service" v-for="service in freightsolutionServices" :value="service">
              {{ service }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label>Colli type</label>
      <input type="text" v-model="value.colli_type" class="form-control" />
    </div>
    <div class="form-group">
      <label>Add ons</label>
      <div class="mb-2">
        <div class="badge badge-primary m-1" v-for="(add_on, idx) in value.add_ons">
          {{ add_on }}
          <i class="fa fa-times p-2" @click="value.add_ons.splice(idx, 1)"></i>
        </div>
      </div>
      <input type="text" v-model="newAddOn" @keydown.enter="setAddOn" class="form-control" />
    </div>
    <div class="form-group">
      <label>Service Attributes</label>
      <ul>
        <li v-for="(v, k) in value.service_attributes">
          {{ k }} : {{ v }}
          <i class="fa fa-times p-2" @click="$delete(value.service_attributes, k)"></i>
        </li>
      </ul>
      <div class="row">
        <div class="col">
          <input type="text" v-model="newParameterKey" class="form-control" />
        </div>
        <div class="col">
          <input type="text" v-model="newParameterValue" class="form-control" />
        </div>
        <div class="col-auto">
          <div class="btn btn-outline-primary" @click="addParameter">Add param</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    services: Array,
    freightsolutionServices: Array
  },
  data() {
    return {
      newAddOn: '',
      newParameterValue: '',
      newParameterKey: ''
    };
  },
  methods: {
    addParameter() {
      if (this.newParameterValue.length == 0 || this.newParameterKey == 0) {
        return;
      }
      if (!this.value.service_attributes) {
        this.$set(this.value, 'service_attributes', {});
      }

      this.$set(this.value.service_attributes, this.newParameterKey, this.newParameterValue);

      this.newParameterValue = '';
      this.newParameterKey = '';
    },
    setAddOn() {
      if (this.newAddOn.length == 0) {
        return;
      }

      if (!this.value.add_ons) {
        this.$set(this.value, 'add_ons', []);
      }

      this.value.add_ons.push(this.newAddOn);
      this.newAddOn = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.mapping {
  padding: 10px;
  margin: 10px;
  background-color: #eee;
  border: 1px solid #ddd;
  border-radius: 5px;
}
</style>